import { graphql } from 'graphql-relay';

export const ReceiptPageQuery = graphql`
  query queries_ReceiptPage_Query($orderApiId: String!) {
    viewer {
      id
      ...ReceiptPage_viewer @arguments(orderApiId: $orderApiId)
    }
  }
`;

export const ResetPasswordPageQuery = graphql`
  query queries_ResetPasswordPage_Query {
    viewer {
      id
      ...ResetPasswordPage_viewer
    }
  }
`;

export const MyAccountQuery = graphql`
  query queries_MyAccountPage_Query {
    viewer {
      id
      ...MyAccountPage_viewer
    }
  }
`;

export const OrdersPageQuery = graphql`
  query queries_OrdersPage_Query {
    viewer {
      id
      ...OrdersPage_viewer
    }
  }
`;

export const FavoritesPageQuery = graphql`
  query queries_FavoritesPage_Query {
    viewer {
      id
    }
  }
`;

export const AddressesPageQuery = graphql`
  query queries_AddressesPage_Query {
    viewer {
      id
      id
      ...AddressesPage_viewer
    }
  }
`;

export const PaymentsPageQuery = graphql`
  query queries_PaymentsPage_Query {
    viewer {
      id
      ...PaymentsPage_viewer
    }
  }
`;

export const PrivacyPolicyPageQuery = graphql`
  query queries_PrivacyPolicyPage_Query {
    viewer {
      id
      ...PrivacyPolicyPage_viewer
    }
  }
`;

export const FaqPageQuery = graphql`
  query queries_FaqPage_Query {
    viewer {
      id
      ...FaqPage_viewer
    }
  }
`;

// export const OurStoryPageQuery = graphql`
//   query queries_OurStoryPage_Query {
//     viewer {
//       ...OurStoryPage_viewer
//     }
//   }
// `;

// export const ImpactPagePageQuery = graphql`
//   query queries_ImpactPage_Query {
//     viewer {
//       ...ImpactPage_viewer
//     }
//   }
// `;

// export const WineMakingPageQuery = graphql`
//   query queries_WineMakingPage_Query {
//     viewer {
//       ...WineMakingPage_viewer
//     }
//   }
// `;

export const ReturnPageQuery = graphql`
  query queries_ReturnPage_Query {
    viewer {
      id
      ...ReturnPage_viewer
    }
  }
`;

export const WeddingsPageQuery = graphql`
  query queries_WeddingsPage_Query {
    viewer {
      id
      ...WeddingsPage_viewer
    }
  }
`;

export const Shimmer2018PageQuery = graphql`
  query queries_Shimmer2018Page_Query {
    viewer {
      id
      ...Shimmer2018Page_viewer
    }
  }
`;
